import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import Immutable from "immutable";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalCreate, guardarUsuario } from "../actions";
import {
  showHideModalSelector,
  selectFromSelector
} from "../../Layout/actions";

class ModalCreate extends Component {
  handleOpenSelector = (columns, reducer, path) => {
    const payload = {};
    const fn = a => {
      payload.reducer = reducer;
      payload.path = path;
      payload.value = Immutable.fromJS(a);
      this.props.selectFromSelector(payload);
    };
    this.props.showHideModalSelector(
      true,
      "Listado de usuarios del sistema",
      "User",
      columns,
      fn,
      []
    );
  };

  modalContent = () => {
    const buttons = [];
    if (this.props.elementos.filter(x => x === "GsUuRYzK").count())
      buttons.push(
        <BoxButton
          key="ba[-1][0]"
          name="floppy-o"
          title="Guardar"
          disabled={this.props.saving}
        />
      );

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.guardarUsuario();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label className="control-label">Identificación</label>
                <Input
                  type="text"
                  reducer="usuarios"
                  path="modalCreate.data.username"
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <label className="control-label">Nombre</label>
                <Input
                  type="text"
                  reducer="usuarios"
                  path="modalCreate.data.name"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Email</label>
                <Input
                  type="text"
                  reducer="usuarios"
                  path="modalCreate.data.email"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Area</label>
                <Input
                  type="test"
                  reducer="usuarios"
                  path="modalCreate.data.area"
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="control-label">Extensión</label>
                <Input
                  type="text"
                  reducer="usuarios"
                  path="modalCreate.data.extension"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="control-label">Estado</label>
                <Input
                  type="select"
                  reducer="usuarios"
                  path="modalCreate.data.active"
                  options={[
                    { value: true, caption: "ACTIVO" },
                    { value: false, caption: "INACTIVO" }
                  ]}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="control-label">Rol</label>
                <Input
                  type="select"
                  reducer="usuarios"
                  path="modalCreate.data.role_id"
                  options={this.props.modalCreate.get("roles").toJS()}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCreate } = this.props;

    return (
      <Modal
        ancho="40vw"
        mostrar={modalCreate.get("show")}
        contenido={this.modalContent()}
        titulo="Creacion/Modificacion de centros de costo"
        nombre="modal_create_usuarios"
        onCerrarModal={() => this.props.showHideModalCreate(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreate: state.usuarios.get("modalCreate"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCreate,
  guardarUsuario,
  showHideModalSelector,
  selectFromSelector
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate);
